import React, { useState } from 'react';
import { FaSearch, FaTimes, FaChevronDown } from 'react-icons/fa';
import './FiltroClientes.css'; // We will create this file next

const defaultFilters = {
  id: '',
  nome: '',
  documento: '',
  tipo: '',
  contribuinte_origem: '',
  apenas_proprietarios: false,
};

const FilterField = ({ name, label, value, onChange, placeholder, type = 'text', as = 'input' }) => {
  return (
    <div className={`filter-field filter-${name}`}>
      <label htmlFor={name}>{label}</label>
      {as === 'input' ? (
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
        />
      ) : null}
    </div>
  );
};

const CheckboxField = ({ name, label, checked, onChange }) => (
  <div className="filter-field filter-checkbox">
    <label htmlFor={name}>
      <input
        type="checkbox"
        id={name}
        name={name}
        checked={checked}
        onChange={onChange}
      />
      {label}
    </label>
  </div>
);

export default function FiltroClientes({ onSearch }) {
  const [isOpen, setIsOpen] = useState(false);
  const [filters, setFilters] = useState(defaultFilters);

  const handleChange = e => {
    const { name, value, type, checked } = e.target;
    setFilters(f => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    onSearch(filters);
  };

  const handleReset = () => {
    setFilters(defaultFilters);
    onSearch(defaultFilters);
  };

  return (
    <div className="filter-accordion">
      <button className="filter-accordion-header" onClick={() => setIsOpen(!isOpen)}>
        <span>Filtros de Pesquisa de Clientes</span>
        <FaChevronDown className={`chevron-icon ${isOpen ? 'open' : ''}`} />
      </button>
      {isOpen && (
        <div className="filter-accordion-content">
          <form className="filtro-clientes-form" onSubmit={handleSubmit}>
            <div className="filters-grid">
              <FilterField name="id" label="ID" value={filters.id} onChange={handleChange} placeholder="1" />
              <FilterField name="nome" label="Nome" value={filters.nome} onChange={handleChange} placeholder="João da Silva" />
              <FilterField name="documento" label="Documento" value={filters.documento} onChange={handleChange} placeholder="123.456.789-00" />
              <FilterField name="tipo" label="Tipo" value={filters.tipo} onChange={handleChange} placeholder="PF ou PJ" />
              <FilterField name="contribuinte_origem" label="Origem" value={filters.contribuinte_origem} onChange={handleChange} placeholder="12345" />
              <CheckboxField name="apenas_proprietarios" label="Apenas Proprietários" checked={filters.apenas_proprietarios} onChange={handleChange} />
            </div>

            <div className="filter-actions">
              <button type="submit" className="button-primary">
                <FaSearch />
                <span>Buscar</span>
              </button>
              <button type="button" className="button-secondary" onClick={handleReset}>
                <FaTimes />
                <span>Limpar</span>
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
